import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  template: `<a *ngIf="accountId" href="#{{url}}">{{accountId}}</a>`
})
export class AccountLinkCellComponent implements ICellRendererAngularComp {

  url: any;
  accountId: any;

  constructor(private router: Router) {}

  agInit(params: any): void {
    this.url = this.router.createUrlTree(['erm/accounts', params.value]);
    this.accountId = params.value;
  }

  refresh(): boolean {
    return false;
  }
}
